import OrganizationCollected from './OrganizationCollected';
import people from '@sb1/ffe-icons/icons/open/300/xl/people.svg';
import moneyBag from '@sb1/ffe-icons/icons/open/300/xl/money_bag.svg';
import { Heading2 } from '@sb1/ffe-core-react';
import { InputGroup } from '@sb1/ffe-form-react';
import { Dropdown } from '@sb1/ffe-dropdown-react';
import {
    LAST_SEVEN_DAYS,
    LAST_YEAR,
    THIS_YEAR,
    SINCE_START,
    SELF_DEFINED,
    TODAY,
    YESTERDAY,
    THIS_MONTH,
    LAST_THREE_MONTHS,
    LAST_SIX_MONTHS,
} from './organization-statistics-model';
import { Datepicker } from '@sb1/ffe-datepicker-react';
import { useEffect, useState } from 'react';
import OrganizationStatisticsDateUtils from './OrganizationStatisticsDateUtils';
import { formatMoneyKr, formatNumber, formatToNbDate } from '../../../utils';
import { Card } from '../../../components/card/Card';
import styles from './organization-statistics.module.less';
import { fetchOrganizationGiversStatistics } from './organization-statistics-actions';
import { useSelector } from 'react-redux';
import moment from 'moment';
import OrganizationVisited from './OrganizationVisited';
import OrganizationStatisticsDonationsCard from './OrganizationStatisticsDonationsCard';

const OrganizationStatistics = ({ organization }) => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [giverStats, setGiverStats] = useState();
    const [selected, setSelected] = useState(SINCE_START);
    const baseURL = useSelector((s) => s.baseURL);
    const organizationStatisticsUtils = new OrganizationStatisticsDateUtils(organization.created_at);

    const updateFromDate = (fromDate) => {
        const key = organizationStatisticsUtils.getPredefinedKey({ fromDate, toDate });
        setFromDate(fromDate);
        setSelected(key || SELF_DEFINED);
    };

    const updateToDate = (toDate) => {
        const key = organizationStatisticsUtils.getPredefinedKey({ fromDate, toDate });
        setToDate(toDate);
        setSelected(key || SELF_DEFINED);
    };

    const setDates = (dateType) => {
        const dateValues = organizationStatisticsUtils.getDateValues(dateType);
        setFromDate(dateValues.fromDate);
        setToDate(dateValues.toDate);
    };

    useEffect(() => {
        if (organization?.id) {
            if (moment(fromDate, 'DD.MM.YYYY', true).isValid() && moment(toDate, 'DD.MM.YYYY', true).isValid()) {
                fetchOrganizationGiversStatistics({
                    baseURL,
                    organizationId: organization.id,
                    from: moment(fromDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    to: moment(toDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                }).then((stats) => {
                    setGiverStats(stats);
                });
            }
        }
    }, [organization?.id, fromDate, toDate]);

    useEffect(() => {
        setDates(SINCE_START);
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <Heading2>Rapporter</Heading2>
                <div className={styles.choosePeriod}>
                    <InputGroup label="Velg periode">
                        <Dropdown
                            value={selected}
                            onChange={(evt) => {
                                setSelected(evt.target.value);
                                setDates(evt.target.value);
                            }}
                        >
                            <option value={SINCE_START}>Siden oppstart</option>
                            <option value={TODAY}>I dag</option>
                            <option value={YESTERDAY}>I går</option>
                            <option value={LAST_SEVEN_DAYS}>Siste 7 dager</option>
                            <option value={THIS_MONTH}>Denne måneden</option>
                            <option value={LAST_THREE_MONTHS}>Siste 3 måneder</option>
                            <option value={LAST_SIX_MONTHS}>Siste 6 måneder</option>
                            <option value={THIS_YEAR}>I år</option>
                            <option value={LAST_YEAR}>I fjor</option>
                            <option value={SELF_DEFINED} disabled>
                                Egendefinert
                            </option>
                        </Dropdown>
                    </InputGroup>
                    <InputGroup label={'Fra'} labelId={'datepicker-from'}>
                        <Datepicker
                            locale="nb"
                            maxDate={toDate || formatToNbDate(new Date())}
                            minDate={formatToNbDate(organization.created_at) || '01.01.2016'}
                            onChange={updateFromDate}
                            value={fromDate}
                            labelId={'datepicker-from'}
                        />
                    </InputGroup>
                    <InputGroup label={'Til'} labelId={'datepicker-to'}>
                        <Datepicker
                            locale="nb"
                            maxDate={formatToNbDate(new Date())}
                            minDate={fromDate}
                            onChange={updateToDate}
                            value={toDate}
                            labelId={'datepicker-to'}
                        />
                    </InputGroup>
                </div>
                <Card title={'Donasjoner'}>
                    <div className={styles.statsBlocks}>
                        <OrganizationStatisticsDonationsCard
                            iconFileUrl={people}
                            title="Antall donasjoner"
                            tooltipText="Noen givere kan ha donert flere ganger"
                            number={formatNumber(giverStats?.givers)}
                        />
                        <OrganizationStatisticsDonationsCard
                            iconFileUrl={moneyBag}
                            title="Snittbeløp donasjoner"
                            tooltipText="Totalt innsamlet beløp delt på antall donasjoner"
                            number={formatMoneyKr(giverStats?.averageAmount, true)}
                        />
                        <OrganizationStatisticsDonationsCard
                            iconFileUrl={moneyBag}
                            title="Typetall donasjoner"
                            tooltipText="Donasjonsbeløpet som forekommer flest ganger"
                            number={formatMoneyKr(giverStats?.mode)}
                        />
                    </div>
                </Card>
                <OrganizationCollected
                    organizationId={organization.id}
                    from={fromDate}
                    to={toDate}
                    setFrom={setFromDate}
                    setTo={setToDate}
                />

                <OrganizationVisited
                    organizationId={organization.id}
                    from={fromDate}
                    to={toDate}
                    setFrom={setFromDate}
                    setTo={setToDate}
                />
            </div>
        </div>
    );
};

export default OrganizationStatistics;
